import React, { useEffect, useRef } from "react";
import { CropperFade } from "react-advanced-cropper";
import cn from "classnames";
import Navigation from "./Navigation";
import Spinner from "./Icons/Spinner";

const CropperWrapper = ({
    cropper,
    children,
    loaded,
    loading,
    className = "",
    spinnerClassName = "",
    navigation = true,
    navigationProps = {},
}) => {
    const navigationRef = useRef(null);

    const state = cropper ? cropper.getState() : null;
    const transitions = cropper ? cropper.getTransitions() : {};
    const transforms = cropper ? cropper.getTransforms() : {};
    const rotate = transforms.rotate || 0;

    useEffect(() => {
        if (navigationRef.current && navigationRef.current.refresh) {
            navigationRef.current.refresh();
        }
    }, [
        state && state.boundary ? state.boundary.width : 0,
        state && state.boundary ? state.boundary.height : 0,
    ]);

    // ✅ 🔥 FIXED FLIP HANDLER
    const handleFlip = (horizontal = false, vertical = false) => {
        if (!cropper) return;

        cropper.flipImage({
            horizontal,
            vertical,
        });
    };

    return (
        <div
            className={cn(
                "rmc-cropper-wrapper",
                {
                    "rmc-cropper-wrapper--with-navigation": navigation,
                },
                className
            )}
        >
            <CropperFade className="rmc-cropper-wrapper__fade" visible={loaded}>
                {children}

        {/* Navigation (Rotate / Flip UI) */}
        {navigation && cropper && (
            <Navigation
                ref={navigationRef}
                value={rotate}
                onRotate={(angle, options) => cropper.rotateImage(angle, options)}
                onRotateEnd={() => cropper.transformImageEnd()}
                onFlip={(horizontal, vertical) => cropper.flipImage(horizontal, vertical)}
                disabled={transitions ? transitions.active : false}
                {...navigationProps}
            />
        )}
        </CropperFade>

            {loading && (
                <div className={cn("rmc-cropper-wrapper__spinner", spinnerClassName)}>
                    <Spinner />
                </div>
            )}
        </div>
    );
};

export default CropperWrapper;